module.exports = __webpack_public_path__ + "assets/img/29_236.abb2ffd6.jpg";